<template>
  <v-data-table
    :headers="headers"
    :items="relatoriosTabela"
    :items-per-page="-1"
    :search="opcoes.pesquisa"
    :sort-by="opcoes.ordenarPor"
    :sort-desc="opcoes.decrescente"
    disable-pagination
    hide-default-footer
    class="elevation-0"
  >
    <!-- ordenar por e pesquisar -->
    <template v-slot:top>
      <v-row class="mb-2">
        <v-toolbar flat>
          <v-toolbar-title>
            <h2 class="title primary--text text--darken-1 text-no-wrap">
              {{ titulo }}
            </h2>
          </v-toolbar-title>
        </v-toolbar>
      </v-row>

      <!-- ordenar por -->
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <app-sort v-model="opcoes" />
        </v-col>

        <v-col
          cols="0"
          md="4"
        />

        <!-- pesquisar -->
        <v-col
          cols="12"
          md="4"
        >
          <app-search v-model="opcoes" />
        </v-col>
      </v-row>
    </template>

    <!-- total de quantidades -->
    <template v-slot:[`body.append`]>
      <tr>
        <td />
        <td align="center">
          <strong class="subtitle-2 grey--text text--darken-2">TOTAL</strong>
        </td>
        <td
          v-for="(total, i) in totais"
          :key="i"
          :item="total"
          align="center"
        >
          <strong>{{ total }}</strong>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import _ from 'lodash';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';

export default {
  name: 'TabelaQuadroResumo',

  components: { AppSort, AppSearch },

  props: {
    relatorios: {
      type: Array,
      required: true,
    },
    titulo: {
      type: String,
      required: true,
    },
    perspectiva: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      headers: [
        {
          text: 'NOME DA UNIDADE',
          value: 'unidade.nome',
          width: '30%',
          sortable: false,
        },
        {
          text: 'SIGLA DA UNIDADE',
          value: 'unidade.sigla',
          width: '20%',
          align: 'center',
        },
        {
          text: 'TOTAL DE SERVIDORES',
          value: 'totalServidores',
          width: '10%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'DISPENSADOS',
          value: 'totalDispensados',
          width: '10%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'PENDENTES',
          value: 'totalPendentes',
          width: '10%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'CONCLUÍDOS',
          value: 'totalConcluidos',
          width: '10%',
          sortable: false,
          align: 'center',
        },
        {
          text: 'PERCENTUAL DE CONCLUSÃO DA UNIDADE',
          value: 'pctConclusaoStr',
          width: '10%',
          sortable: false,
          align: 'center',
        },
      ],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'unidade.nome',
        selecionado: { id: 'unidade.nome', descricao: 'Nome da Unidade' },
        lista: [
          { id: 'unidade.nome', descricao: 'Nome da Unidade' },
          { id: 'unidade.sigla', descricao: 'Sigla da Unidade' },
          { id: 'totalServidores', descricao: 'Total de Servidores' },
          { id: 'totalDispensados', descricao: 'Total de Servidores Dispensados' },
          { id: 'totalPendentes', descricao: 'Total de Servidores Pendentes' },
          { id: 'totalConcluidos', descricao: 'Total de Servidores Concluídos' },
          { id: 'pctConclusao', descricao: 'Percentual de Conclusão da Unidade' },
        ],
      },
    };
  },

  computed: {
    relatoriosTabela() {
      return this.relatorios.map((r) => {
        const totais = this.perspectiva === 'TECNICA' ? r.totaisTecnico : r.totaisComportamental;
        const totalParticipantes = totais.totalConcluidos + totais.totalPendentes;
        const pctConclusao = this.calcularPct(totais.totalConcluidos, totalParticipantes);

        return {
          ...r,
          ...totais,
          pctConclusao: pctConclusao == null ? -1 : pctConclusao,
          pctConclusaoStr: this.calcularPctStr(pctConclusao),
          totalServidores: r.servidores.length,
        };
      });
    },
    totais() {
      const totalConcluidos = _(this.relatoriosTabela).sumBy('totalConcluidos');
      const totalPendentes = _(this.relatoriosTabela).sumBy('totalPendentes');
      const totalParticipantes = totalConcluidos + totalPendentes;
      const pctConclusao = this.calcularPct(totalConcluidos, totalParticipantes);

      return [
        _(this.relatoriosTabela).sumBy('totalServidores'),
        _(this.relatoriosTabela).sumBy('totalDispensados'),
        totalPendentes,
        totalConcluidos,
        this.calcularPctStr(pctConclusao),
      ];
    },
  },

  methods: {
    calcularPct(nume, deno) {
      if (deno > 0) {
        return nume / deno;
      }
      return null;
    },
    calcularPctStr(pct) {
      if (pct !== null) {
        pct *= 100;
        return `${pct.toLocaleString(undefined, {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        })}%`;
      }
      return `${0}%`;
    },
  },
};
</script>
